import { createContext, useContext, useEffect, useRef } from "react";

/**
 * Liga o formulário de criação (que conhece o próprio estado) à barra de rascunho da página Nova
 * Solicitação (que salva/restaura). O formulário só informa como ler e como aplicar seus campos.
 */
export const RascunhoContext = createContext(null);

/**
 * @param obter   () => objeto com os campos a guardar (sem anexos)
 * @param aplicar (dados) => void — recoloca um rascunho salvo nos estados do formulário
 */
export function useRascunhoFormulario(obter, aplicar) {
    const contexto = useContext(RascunhoContext);
    const ref = useRef({ obter, aplicar });
    ref.current = { obter, aplicar };

    useEffect(() => {
        if (!contexto) return undefined;
        return contexto.registrar({
            obter: () => ref.current.obter(),
            aplicar: dados => ref.current.aplicar(dados),
        });
    }, [contexto]);
}
